<div mat-dialog-title class="matDialogTitle" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
    <mat-progress-bar mode="indeterminate" [hidden]="!loading" class="detaile"></mat-progress-bar>
    <span>
        <span>{{ title }}</span>
    </span>
    <span (click)="close()">
        <mat-icon class="close">close</mat-icon>
    </span>
</div>
<div mat-dialog-content class="matDialogContent">
    <div class="row">
        <div class="row" *ngIf="list_record.length > 0">
            <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-xs-12 right" style="padding:0px">
                <span>در قسمت پایین می توانید شماره سریال کالای فروخته شده را انتخاب کنید</span>
            </div>
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 right pe padding0"
                *ngFor="let x of list_record;let i = index">
                <span>
                    <mat-checkbox name="searial[]" value="{{ x.wharehouse_order_sale_searial_id }}"
                        (change)="select_items(1)"
                        [checked]="x.checked || (searial_selected && searial_selected.indexOf(x.wharehouse_order_sale_searial_id) != -1)"
                        [disabled]="searial_used.indexOf(x.wharehouse_order_sale_searial_id) != -1 || readonly == true">
                    </mat-checkbox>
                </span>
                <span style="vertical-align: top;">
                    <span *ngIf="searial_used.indexOf(x.wharehouse_order_sale_searial_id) != -1"><del>{{
                            x.wharehouse_order_sale_searial_title }}</del></span>
                    <span *ngIf="searial_used.indexOf(x.wharehouse_order_sale_searial_id) == -1">{{
                        x.wharehouse_order_sale_searial_title }}</span>
                </span>
            </div>
        </div>
        <ng-container *ngIf="list_record.length == 0">
            <div class="row" class="preview1" [hidden]="count_total > 0">
                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div>
                        <img src="../../../assets//images/preview.png">
                    </div>
                    <div class="preview2">{{ messageService.get_no_record_text() }}</div>
                </div>
            </div>
        </ng-container>
    </div>
</div>
<div mat-dialog-actions align="start" class="pe1 matDialogActions" style="padding-right:25px" *ngIf="readonly != true">
    <button type="submit" class="btn_pe" *ngIf="list_record.length > 0" (click)="select_items(2)">
        <span>ذخیره</span>
    </button>
</div><!-- row -->